<h1 mat-dialog-title>{{data.titleText}}</h1>
<mat-dialog-actions class="dialog-navigation" align="end">
    <button mat-button color="primary" mat-dialog-close="true">Okay</button>
</mat-dialog-actions>